import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const FilterContext = createContext();

export function FilterProvider({children}){
    const [filterOpen, setFilterOpen] = useState(false);
    const [filters, setFilters] = useState({});
    const [search, setSearch] = useState("");

    const location = useLocation();

    useEffect(() => {
        if (!location.pathname.startsWith("/dashboard")){
            setFilterOpen(false);
            setFilters({});
            setSearch("");
        }
    }, [location.pathname]);

    return (
        <FilterContext.Provider value={{filterOpen, setFilterOpen, filters, setFilters, search, setSearch}}>
            {children}
        </FilterContext.Provider>
    );
}